import AddIcon from '@mui/icons-material/Add';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PersonIcon from '@mui/icons-material/Person';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { Box, Button, Grid, Typography } from '@mui/material';
import { formatPhoneNumber } from '../../container/Common/FormatPhoneNumber';

const SuccessView = ({ customers = [], newCustomer = null, deliveryMethod = [], onClose, onSendAnother }) => {
    const isNewCustomer = !customers || customers.length === 0;

    const displayList = isNewCustomer
        ? newCustomer
            ? [
                  {
                      id: 'new',
                      name: newCustomer.firstName,
                      phone: newCustomer.phoneNumber,
                      email: newCustomer.email,
                  },
              ]
            : []
        : customers;

    const isSingle = displayList.length === 1;

    const buildDeliveryLabel = () => {
        const labels = [];
        if (deliveryMethod.includes('text')) labels.push('text');
        if (deliveryMethod.includes('email')) labels.push('email');
        if (deliveryMethod.includes('APP') || deliveryMethod.includes('app')) labels.push('Apex Auto App');

        if (!labels.length) return '';
        if (labels.length === 1) return `via ${labels[0]}.`;

        const last = labels.pop();
        return `via ${labels.join(', ')} and ${last}.`;
    };

    const SingleCustomerRow = ({ customer }) => (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 2,
                py: 1.5,
                borderRadius: '8px',
                border: '1px solid #E5E7EB',
                background: '#FAFBFF',
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Box display="flex" alignItems="center" gap={0.75}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <g clip-path="url(#clip0_23407_620790)">
                            <path
                                d="M9 9C10.6575 9 12 7.6575 12 6C12 4.3425 10.6575 3 9 3C7.3425 3 6 4.3425 6 6C6 7.6575 7.3425 9 9 9ZM9 10.5C6.9975 10.5 3 11.505 3 13.5V14.25C3 14.6625 3.3375 15 3.75 15H14.25C14.6625 15 15 14.6625 15 14.25V13.5C15 11.505 11.0025 10.5 9 10.5Z"
                                fill="#006CDD"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_23407_620790">
                                <rect width="18" height="18" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>{customer?.name}</Typography>
                </Box>

                <Box display="flex" gap={2}>
                    {(customer?.phone || customer?.phoneNumber) && (
                        <Box display="flex" gap={'8px'} alignItems={'center'}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <g clip-path="url(#clip0_23407_620796)">
                                    <path
                                        d="M11.2034 0H4.797C4.3735 0 3.96735 0.168234 3.66789 0.467692C3.36843 0.76715 3.2002 1.1733 3.2002 1.5968V14.4024C3.2002 15.2848 3.9154 16 4.797 16H11.2026C11.6262 16 12.0324 15.8318 12.332 15.5324C12.6316 15.2329 12.8 14.8268 12.8002 14.4032V1.5968C12.8002 1.1733 12.632 0.76715 12.3325 0.467692C12.033 0.168234 11.6269 0 11.2034 0ZM8.0002 15.2C7.4482 15.2 7.0002 14.8424 7.0002 14.4C7.0002 13.9576 7.4482 13.6 8.0002 13.6C8.5522 13.6 9.0002 13.9576 9.0002 14.4C9.0002 14.8424 8.5522 15.2 8.0002 15.2ZM11.2002 12.8H4.8002V1.6H11.2002V12.8Z"
                                        fill="#006CDD"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_23407_620796">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <Typography sx={{ fontSize: '14px' }}>
                                {customer?.phone || customer?.phoneNumber ? formatPhoneNumber(customer?.phone || customer?.phoneNumber) : '—'}
                            </Typography>
                        </Box>
                    )}

                    {customer?.email && (
                        <Box display="flex" gap={'8px'} alignItems={'center'}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <g clip-path="url(#clip0_23407_620799)">
                                    <path
                                        d="M14.6668 3.99996C14.6668 3.26663 14.0668 2.66663 13.3335 2.66663H2.66683C1.9335 2.66663 1.3335 3.26663 1.3335 3.99996V12C1.3335 12.7333 1.9335 13.3333 2.66683 13.3333H13.3335C14.0668 13.3333 14.6668 12.7333 14.6668 12V3.99996ZM13.3335 3.99996L8.00016 7.33329L2.66683 3.99996H13.3335ZM13.3335 12H2.66683V5.33329L8.00016 8.66663L13.3335 5.33329V12Z"
                                        fill="#006CDD"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_23407_620799">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <Typography sx={{ fontSize: '14px' }}>{customer?.email || '—'}</Typography>
                        </Box>
                    )}
                </Box>
            </Box>

            {/* Sent badge */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '8px 14px',
                    borderRadius: '24px',
                    background: '#E8F5E9',
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path
                        d="M5.94947 7.21784C5.83798 7.10656 5.70512 7.019 5.55889 6.96046L0.933053 5.10546C0.877821 5.0833 0.830691 5.04477 0.797987 4.99505C0.765283 4.94533 0.748572 4.88679 0.750096 4.8273C0.751619 4.76781 0.771306 4.7102 0.806512 4.66222C0.841718 4.61424 0.890759 4.57818 0.947053 4.55887L12.0304 0.767207C12.0821 0.748538 12.138 0.744975 12.1916 0.756935C12.2453 0.768896 12.2944 0.795885 12.3333 0.834744C12.3721 0.873603 12.3991 0.922726 12.4111 0.976364C12.423 1.03 12.4195 1.08594 12.4008 1.13762L8.60914 12.221C8.58983 12.2773 8.55377 12.3263 8.50579 12.3615C8.45781 12.3967 8.4002 12.4164 8.34071 12.4179C8.28122 12.4194 8.22268 12.4027 8.17296 12.37C8.12324 12.3373 8.08471 12.2902 8.06255 12.235L6.20755 7.60796C6.14874 7.46183 6.06095 7.32912 5.94947 7.21784ZM5.94947 7.21784L12.3315 0.837158"
                        stroke="#21A363"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#21A363' }}>Sent</Typography>
            </div>
        </Box>
    );

    const CustomerCard = ({ customer }) => (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.5,
                p: 1.5,
                borderRadius: '8px',
                background: '#FAFBFF',
                border: '1px solid #E5E7EB',
                height: '100%',
            }}
        >
            <Box display="flex" gap={0.75}>
                <PersonIcon sx={{ width: 18, height: 18, color: '#006CDD' }} />
                <Typography sx={{ fontSize: '14px', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {customer?.name}
                </Typography>
            </Box>
            {(customer?.phone || customer?.phoneNumber) && (
                <Box display="flex" gap={0.75}>
                    <PhoneAndroidIcon sx={{ width: 16, height: 16, color: '#006CDD' }} />
                    <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>
                        {customer?.phone || customer?.phoneNumber ? formatPhoneNumber(customer?.phone || customer?.phoneNumber) : '—'}
                    </Typography>
                </Box>
            )}
            {customer?.email && (
                <Box display="flex" gap={0.75}>
                    <MailOutlineIcon sx={{ width: 14, height: 14, color: '#1976D2' }} />
                    <Typography sx={{ fontSize: '14px', fontWeight: '400', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {customer?.email || '—'}
                    </Typography>
                </Box>
            )}
        </Box>
    );

    const Sparkles = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="164" height="130" viewBox="0 0 164 130" fill="none">
            <path
                opacity="0.7"
                d="M138.562 24.472C138.884 23.6014 140.116 23.6014 140.438 24.472L141.366 26.9806C141.467 27.2543 141.683 27.4701 141.957 27.5714L144.465 28.4996C145.336 28.8218 145.336 30.0532 144.465 30.3754L141.957 31.3036C141.683 31.4049 141.467 31.6207 141.366 31.8944L140.438 34.403C140.116 35.2736 138.884 35.2736 138.562 34.403L137.634 31.8944C137.533 31.6207 137.317 31.4049 137.043 31.3036L134.535 30.3754C133.664 30.0532 133.664 28.8218 134.535 28.4996L137.043 27.5714C137.317 27.4701 137.533 27.2543 137.634 26.9806L138.562 24.472Z"
                fill="#27A96B"
            />
            <path
                opacity="0.6"
                d="M10.735 103.308C10.6519 102.383 11.7639 101.854 12.4288 102.502L14.0659 104.097C14.2749 104.301 14.5625 104.403 14.8532 104.377L17.1297 104.173C18.0543 104.09 18.5832 105.202 17.9354 105.867L16.3403 107.504C16.1366 107.713 16.0344 108 16.0605 108.291L16.2649 110.567C16.348 111.492 15.236 112.021 14.5711 111.373L12.934 109.778C12.725 109.574 12.4374 109.472 12.1467 109.498L9.8702 109.703C8.94561 109.786 8.4167 108.674 9.06453 108.009L10.6596 106.372C10.8633 106.163 10.9655 105.875 10.9394 105.584L10.735 103.308Z"
                fill="#27A96B"
            />
            <circle opacity="0.7" cx="3.5" cy="58.4375" r="3.5" fill="#27A96B" />
            <circle opacity="0.2" cx="161.5" cy="63.9375" r="2" fill="#27A96B" />
            <circle opacity="0.5" cx="87.5" cy="127.938" r="2" fill="#27A96B" />
            <circle opacity="0.2" cx="22" cy="24.4375" r="2.5" fill="#27A96B" />
            <path
                opacity="0.5"
                d="M140 91.9375L141.215 95.2221L144.5 96.4375L141.215 97.6529L140 100.938L138.785 97.6529L135.5 96.4375L138.785 95.2221L140 91.9375Z"
                fill="#27A96B"
            />
            <path
                opacity="0.5"
                d="M67.1685 1.73918L67.1167 5.49961L69.9377 7.98672L66.1772 7.93493L63.6901 10.7559L63.7419 6.99546L60.921 4.50835L64.6814 4.56013L67.1685 1.73918Z"
                fill="#27A96B"
            />
        </svg>
    );

    /* -------------------- MAIN UI -------------------- */

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 3, pt: 3 }}>
            {/* Success Icon */}
            <Box
                sx={{
                    position: 'relative',
                    width: '163.5px',
                    height: '129.938px',
                    mb: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Sparkles />

                <Box
                    sx={{
                        position: 'absolute',
                        width: 94,
                        height: 94,
                    }}
                />

                <Box
                    sx={{
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="94" height="94" viewBox="0 0 94 94" fill="none">
                        <g clip-path="url(#clip0_23444_17550)">
                            <circle cx="47" cy="47" r="47" fill="#EEF9F4" />
                            <circle cx="47" cy="47" r="17" fill="white" />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M47 22C60.8047 22 72 33.1953 72 47C72 60.8047 60.8047 72 47 72C33.1953 72 22 60.8047 22 47C22 33.1953 33.1953 22 47 22ZM41.8084 55.1202L35.6878 48.9945C34.6451 47.9511 34.6449 46.2497 35.6878 45.2066C36.731 44.1636 38.44 44.1702 39.4756 45.2066L43.7906 49.525L54.5248 38.7907C55.568 37.7475 57.2696 37.7475 58.3126 38.7907C59.3557 39.8337 59.3542 41.5367 58.3126 42.5784L45.6814 55.2096C44.6397 56.2513 42.9366 56.2528 41.8936 55.2096C41.8643 55.1803 41.8361 55.1506 41.8084 55.1202Z"
                                fill="#27A96B"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_23444_17550">
                                <rect width="94" height="94" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </Box>
            </Box>

            {/* Title */}
            <Typography sx={{ fontSize: '24px', fontWeight: 600, color: '#040404', mb: 0.75 }}>Request Sent!</Typography>

            {/* Subtitle */}
            <Typography sx={{ fontSize: '18px', fontWeight: 400, textAlign: 'center', mb: 3, color: '#616161' }}>
                {isSingle ? (
                    <>
                        Your review request has been sent to{' '}
                        <Box component="span" sx={{ fontWeight: 700, fontSize: '18px', color: '#616161' }}>
                            {displayList[0]?.name}
                        </Box>{' '}
                        {buildDeliveryLabel()}
                    </>
                ) : (
                    <>
                        <Box component="span" sx={{ fontWeight: 700, fontSize: '18px', color: '#616161' }}>
                            {displayList.length}
                        </Box>{' '}
                        review requests have been sent successfully.
                    </>
                )}
            </Typography>

            {/* Customers */}
            <Box sx={{ width: '100%', mb: 3 }}>
                {isSingle ? (
                    <SingleCustomerRow customer={displayList[0]} />
                ) : (
                    <Grid container spacing={1.5} justifyContent="center">
                        {displayList.map((c, i) => (
                            <Grid item xs={12} sm={4} key={i}>
                                <CustomerCard customer={c} />
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Box>

            {/* Footer */}

            <Box
                sx={{
                    width: '100%',
                    borderTop: '1px solid #E5E7EB',
                    pt: 2.5,
                    pb: 2.5,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '19px',
                }}
            >
                <Button variant="outlined" startIcon={<AddIcon />} onClick={onSendAnother}>
                    Send Another
                </Button>

                <Button variant="contained" onClick={onClose}>
                    Done
                </Button>
            </Box>
        </Box>
    );
};

export default SuccessView;
